;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.Tipping = function () {

	};

	_.extend(Controller.Tipping.prototype, {
		start:          function (league_id) {
			this.view = new Layout.RightSidebar();

			APP.main.show(this.view);

			this.tippingLayout = new Layout.TippingRegions();

			this.view.main.show(this.tippingLayout);

			this.getJSONData();

			this.user = APP.module('instance').user;

			this.share = new Model.Share();

			this.view.aside.show(this.getWidgets(league_id));

			this.tippingLayout.gamebar.show(this.getGamebar());
			this.showNotificationBanner();

		},
		getJSONData:    function () {
			this.rounds = new Collection.Rounds();
			this.squads = new Collection.Squads();
			this.venues = new Collection.Venues();
		},
		getTippingData: function () {
			this.tipping_data = new Model.Tipping();
		},
		gamesList:      function () {
			this.start();
			this.getTippingData();

			var controls = new View.TippingControls({
					rounds:   this.rounds,
					round_id: false
				}),
				tips     = new View.TippingTips({
					round_id:        false,
					model:           this.tipping_data,
					rounds:          this.rounds,
					squads:          this.squads,
					venues:          this.venues,
					ladderPredictor: new Model.LadderPredictor(),
					collection:      new Collection.Tipping(),
					checksumEmitter: new APP.ChecksumEmitter()
				});

			this.tippingLayout.controls.show(controls);
			this.tippingLayout.tips.show(tips);

			return this;
		},
		showNotificationBanner: function() {
			if(Model.NotificationBanner) {
				const notificationBanner = new View.NotificationBanner({
					model: new Model.NotificationBanner()
				});
				APP.notification_bar.show(notificationBanner);
			} else if(View.NotificationBanner) {
				console.error('Looks like View.NotificationBanner is enabled but the Model.NotificationBanner is not.')
			}
		},
		leaguesList:    function () {
			this.start();

			var leaguesList = new View.TippingLeaguesList({
				model:                    new Backbone.Model(),
				share:                    this.share,
				leagues:                  new Collection.TippingLeagues(),
				rounds:                   this.rounds,
				user:                     this.user,
				leagues_for_regeneration: Collection.hasOwnProperty('LeaguesRegeneration') ? new Collection.LeaguesRegeneration() : false
			});

			leaguesList.on('leagues_list:empty', this.navigateToLeaguesJoin);
			this.tippingLayout.tips.show(leaguesList);

			return this;
		},
		leaguesJoin:    function () {
			this.start();

			var leaguesJoinFilter = new View.TippingLeaguesJoinFilter(),
				leaguesJoin       = new View.TippingLeaguesJoin({
					model:   new Backbone.Model(),
					leagues: new Collection.TippingLeagues
				});

			leaguesJoin.on('leagues_join:success', this.navigateToLeaguesAbout);
			this.tippingLayout.controls.show(leaguesJoinFilter);
			this.tippingLayout.tips.show(leaguesJoin);

			return this;
		},
		leaguesCreate:  function (league_name) {
			this.start();

			var leaguesCreate = new View.TippingLeaguesCreate({
				league_name: league_name,
				model:       new Backbone.Model(),
				league:      new Model.TippingLeague(),
				rounds:      this.rounds,
				user:        this.user
			});

			leaguesCreate.on('leagues_create:success', this.navigateToLeaguesManage);
			this.tippingLayout.tips.show(leaguesCreate);

			return this;
		},
		leaguesLadder:  function (league_id) {
			this.start(league_id);

			var leaguesLadder = new View.TippingLeaguesLadder({
				league_id: +league_id,
				model:     new Backbone.Model(),
				league:    new Model.TippingLeague(),
				ladder:    new Model.Ladder(),
				leagues:   new Collection.TippingLeagues(),
				rounds:    new Collection.Rounds(),
				user:      this.user
			});

			leaguesLadder.on('leagues:view:menu', _.bind(this.leaguesViewMenu, this));
			leaguesLadder.on('leagues_ladder:change_league', this.navigateToLeaguesLadder);
			leaguesLadder.on('leagues:http_status:404', this.navigateToLeaguesList);
			this.tippingLayout.tips.show(leaguesLadder);

			this._after(league_id);

			return this;
		},
		leaguesAbout:   function (league_id) {
			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: +league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					leagues:   new Collection.TippingLeagues(),
					ladder:    new Model.Ladder(),
					user:      this.user,
					template:  JST.TippingLeaguesManageControlsAboutPage

				}),
				leaguesAbout          = new View.TippingLeaguesAbout({
					league_id:    +league_id,
					model:        new Backbone.Model(),
					league:       new Model.TippingLeague(),
					user:         this.user,
					joined_users: new Collection.TippingCoaches()
				});

			leaguesAbout.on('leagues:view:menu', _.bind(this.leaguesViewMenu, this));
			leaguesAbout.on('leagues_leave:success', this.navigateToLeaguesList);
			leaguesAbout.on('leagues:http_status:404', this.navigateToLeaguesList);

			this.tippingLayout.tips.show(leaguesManage);

			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesAbout);

			this._after(league_id);

			return this;
		},

		leaguesTipsList: function () {
		},

		leaguesInvites:     function (league_id) {
			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: +league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					ladder:    new Model.Ladder(),
					leagues:   new Collection.TippingLeagues(),
					user:      this.user
				}),
				leaguesInvites        = new View.TippingLeaguesInvites({
					league_id: +league_id,
					model:     new Backbone.Model(),
					league:    new Model.TippingLeague(),
					share:     this.share,
					invites:   new Collection.TippingInvites(),
					user:      this.user
				});

			leaguesInvites.on('leagues:manage:menu', _.bind(this.leaguesManageMenu, this));
			leaguesInvites.on('leagues_invites:success', this.navigateToLeaguesTeams);
			leaguesInvites.on('leagues:http_status:404', this.navigateToLeaguesList);
			leaguesInvites.on('leagues:http_status:403', this.navigateToLeaguesList);
			this.tippingLayout.tips.show(leaguesManage);
			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesInvites);

			this._after(league_id);

			return this;
		},
		leaguesCelebrities: function (league_id) {
			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: +league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					ladder:    new Model.Ladder(),
					leagues:   new Collection.TippingLeagues(),
					user:      this.user
				}),
				leaguesCelebrities    = new View.TippingLeaguesCelebrities({
					league_id:   +league_id,
					model:       new Backbone.Model(),
					league:      new Model.TippingLeague(),
					share:       this.share,
					invites:     new Collection.TippingInvites(),
					celebrities: new Collection.TippingCelebrities(),
					user:        this.user
				});

			leaguesCelebrities.on('leagues:manage:menu', _.bind(this.leaguesManageMenu, this));
			leaguesCelebrities.on('leagues_celebrities:success', this.navigateToLeaguesTeams);
			leaguesCelebrities.on('leagues:http_status:404', this.navigateToLeaguesList);
			leaguesCelebrities.on('leagues:http_status:403', this.navigateToLeaguesList);
			this.tippingLayout.tips.show(leaguesManage);
			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesCelebrities);

			this._after(league_id);

			return this;
		},
		leaguesUsers:       function (league_id) {
			this.start(league_id);

			var leaguesManage         = new Layout.TippingLeaguesManage(),
				leaguesManageControls = new View.TippingLeaguesManageControls({
					league_id: +league_id,
					model:     new Backbone.Model(),
					share:     this.share,
					ladder:    new Model.Ladder(),
					leagues:   new Collection.TippingLeagues(),
					user:      this.user
				}),
				leaguesCoaches        = new View.TippingLeaguesCoaches({
					league_id: +league_id,
					model:     new Backbone.Model(),
					league:    new Model.TippingLeague(),
					share:     this.share,
					coaches:   new Collection.TippingCoaches(),
					user:      this.user
				});

			leaguesCoaches.on('leagues:manage:menu', _.bind(this.leaguesManageMenu, this));
			leaguesCoaches.on('leagues:http_status:404', this.navigateToLeaguesList);
			leaguesCoaches.on('leagues:http_status:403', this.navigateToLeaguesList);
			this.tippingLayout.tips.show(leaguesManage);
			leaguesManage.info.show(leaguesManageControls);
			leaguesManage.tabs.show(leaguesCoaches);

			this._after(league_id);

			return this;
		},
		leaguesSettings:    function (league_id) {
			this.start(league_id);
			var leaguesSettings = new View.TippingLeaguesSettings({
				league_id: +league_id,
				model:     new Backbone.Model(),
				league:    new Model.TippingLeague(),
				ladder:    new Model.Ladder(),
				rounds:    this.rounds,
				user:      this.user
			});

			leaguesSettings.on('leagues:view:menu', _.bind(this.leaguesViewMenu, this));
			leaguesSettings.on('leagues_settings:deleted', this.navigateToLeaguesList);
			leaguesSettings.on('leagues:http_status:404', this.navigateToLeaguesList);
			leaguesSettings.on('leagues:http_status:403', this.navigateToLeaguesList);

			this.tippingLayout.tips.show(leaguesSettings);

			this._after(league_id);

			return this;
		},
		leaguesJoinByCode:  function (league_id, league_code) {
			this.start(league_id);

			var leaguesJoinByCode = new View.TippingLeaguesJoinByCode({
				league_id:   +league_id,
				league_code: league_code,
				league:      new Model.TippingLeague()
			});

			leaguesJoinByCode.on('leagues_join_code:success', this.navigateToLeaguesAbout);
			leaguesJoinByCode.on('leagues_join_code:error', this.navigateToLeaguesList);
			this.tippingLayout.controls.show(leaguesJoinByCode);

			return this;
		},

		rankings:                  function () {
			this.start();

			var rankings = new View.TippingRankings({
				model:    new Backbone.Model(),
				rankings: new Collection.TippingRankings(),
				rounds:   new Collection.Rounds(),
				user:     this.user
			});

			this.tippingLayout.tips.show(rankings);

			return this;
		},
		getWidgets:                function () {
			return new Layout.Sidebar({
				widgets_list:    ['Promo', 'RoundTipsStat', 'Promo'],
				widgets_options: {
					rounds:     this.rounds,
					squads:     this.squads,
					collection: new Collection.TippingRoundStats(),
					model:      new Backbone.Model
				}
			});
		},
		getGamebar:                function () {
			this.getTippingData();
			return new View.TippingGamebar({
				tippingModel: this.tipping_data,
				shareModel:   this.share,
				user:         this.user,
				model: new Backbone.Model()
			});
		},
		navigateToLeaguesList:     function () {
			Backbone.history.navigate('#tipping/leagues', {trigger: true});
		},
		navigateToLeaguesJoin:     function () {
			Backbone.history.navigate('#tipping/leagues/join', {trigger: true});
		},
		navigateToLeaguesLadder:   function (league_id) {
			Backbone.history.navigate('#tipping/leagues/' + league_id + '/ladder', {trigger: true});
		},
		navigateToLeaguesFixtures: function (league_id) {
			Backbone.history.navigate('#tipping/leagues/' + league_id + '/fixtures', {trigger: true});
		},
		navigateToLeaguesAbout:    function (league_id) {
			Backbone.history.navigate('#tipping/leagues/' + league_id + '/about', {trigger: true});
		},
		navigateToLeaguesManage:   function (league_id) {
			Backbone.history.navigate('#tipping/leagues/' + league_id + '/manage', {trigger: true});
		},
		navigateToLeaguesTeams:    function (league_id) {
			Backbone.history.navigate('#tipping/leagues/' + league_id + '/manage/users', {trigger: true});
		},
		leaguesViewMenu:           function (league) {

			this.initMenuAndUser();

			if (!this.menu) return this;

			var close_menu_items_arr = [];

			this.menu
				.setBreadcrumb({method_name: 'leaguesList', path: 'tipping/leagues', text: league.get('name')})
				.replace(':league_id', league.get('id'));

			if (league.get('commissioner') !== this.user.get('id')) {
				close_menu_items_arr.push('leaguesSettings', 'leaguesUsers', 'leaguesCelebrities', 'leaguesInvites');
			}

			if (league.get('status') === 'scheduled') {
				close_menu_items_arr.push('leaguesLadder');
			}

			if (!Boolean(parseInt(league.get('coaches_box')))) {
				close_menu_items_arr.push('chat');
			}

			if (league.get('privacy') !== 'private' || league.get('commissioner') !== this.user.get('id')) {
				close_menu_items_arr.push('leaguesEmail');
			}

			this.menu.removeItemFromMenu(close_menu_items_arr).show();

		},

		initMenuAndUser: function () {

			this.menu = this.menu || APP.module('instance').menu;
			this.user = this.user || APP.module('instance').user;

			return this;
		},

		leaguesManageMenu: function (league) {

			if (this.menu) {
				this.menu.setBreadcrumb({
					method_name: 'leaguesList',
					path:        'tipping/leagues',
					text:        league.get('name')
				})
					.replace(':league_id', league.get('id')).show();
			}
		},

		chat: function (league_id) {

			this.start(league_id);

			var chat = new View.CoachesBoxWidget({
				className:            'coach-box-widget full',
				user:                 APP.module('instance').user,
				coachBoxesCollection: new Collection.CoachBoxes()
			});

			var league = new Model.TippingLeague();

			league.show_by_id(league_id)
				.then(_.bind(function () {
					if (Boolean(parseInt(league.get('coaches_box')))) {

						this.view.main.show(chat);

						APP.vent.trigger('league:info', {
							league: league
						});

					} else {

						this.navigateToLeaguesAbout(league_id);

					}
				}, this))
				.then(_.bind(_.partial(this.leaguesViewMenu, league), this));

			return this;

		},

		viewTips: function (league_id) {

			this.start(league_id);

			var chat = new View.CoachesBoxWidget({
				className:            'coach-box-widget full',
				user:                 APP.module('instance').user,
				coachBoxesCollection: new Collection.CoachBoxes()
			});

			var league = new Model.TippingLeague();

			league.show_by_id(league_id)
				.then(_.bind(function () {
					if (Boolean(parseInt(league.get('coaches_box')))) {

						this.view.main.show(chat);

						APP.vent.trigger('league:info', {
							league: league
						});

					} else {

						this.navigateToLeaguesAbout(league_id);

					}
				}, this))
				.then(_.bind(_.partial(this.leaguesViewMenu, league), this));

			return this;

		},

		gauntlet: function () {
			return this;
		},

		_after: function () {

		}
	});

	APP.on('start', function () {
		var controller = new Controller.Tipping();
		var router     = new Router.Tipping({controller: controller});
	});

}(window, APP, Backbone, Marionette, $, _));